import { TProfile, TProfileShort } from '@typings'
import { toString } from '@helpers'

export default function getUserFullName(profile: TProfile | TProfileShort): string {
	return `${toString(profile.firstName)} ${toString(profile.lastName)}`
}
